import { z } from 'zod';
import {
  AppointmentLinkInputSchema,
  AppointmentWriteResponseSchema,
  AttendeeEmailsSchema,
  isIanaZone,
} from './calendar.schemas';

export const VIEWING_INVITATION_HINT_MAX_LENGTH = 500;

export const InviteProspectToViewingPathParamsSchema = z.object({ organizationId: z.uuid(), prospectId: z.uuid() });

export const InviteProspectToViewingBodySchema = z
  .object({
    title: z.string().trim().min(1).max(200),
    startsAt: z.iso.datetime(),
    endsAt: z.iso.datetime(),
    isAllDay: z.boolean().default(false),
    timeZone: z.string().min(1).refine(isIanaZone),
    location: z.string().trim().max(300).optional(),
    notes: z.string().trim().max(5000).optional(),
    hint: z.string().trim().max(VIEWING_INVITATION_HINT_MAX_LENGTH).optional(),
    // Further links. The PROSPECT link is the server's and is added whatever this carries.
    links: z.array(AppointmentLinkInputSchema).max(50).optional(),
    // Further attendees. The Kontakt is invited by immoOS and is never sent to the provider.
    attendees: AttendeeEmailsSchema.optional(),
  })
  .refine((body) => new Date(body.endsAt) > new Date(body.startsAt), { path: ['endsAt'] });
export type InviteProspectToViewingBody = z.input<typeof InviteProspectToViewingBodySchema>;

export const ViewingInvitationResponseSchema = z.object({
  invitationId: z.uuid(),
  appointment: AppointmentWriteResponseSchema,
  phaseMoved: z.boolean(),
});
export type ViewingInvitationResponse = z.infer<typeof ViewingInvitationResponseSchema>;

export const ViewingInvitationPreviewSchema = z.object({
  // The From header the send writes: `"{Firmenname}" <noreply@immoos.ai>`.
  from: z.string(),
  // The Kontakt's primary e-mail address, the send's recipient.
  to: z.string(),
  subject: z.string(),
  // The rendered mail; every inline image is a `data:` URI, so the document needs no network.
  html: z.string(),
});
export type ViewingInvitationPreview = z.infer<typeof ViewingInvitationPreviewSchema>;
